<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 512 512" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M461.7 481.4c0 13.1-8.7 23.6-19.5 23.7l-372.4.4c-10.8 0-19.5-10.6-19.5-23.6l-.4-451.8c0-13.1 8.7-23.6 19.5-23.7l274-.3 118 110.7.3 364.6z" fill="#ffb22a" />
      <path fill="none" d="M50 6h412v500H50z" />
      <path d="m461.7 119.7-99.4.1c-10.8 0-19.5-10.6-19.5-23.6L342.7 9l119 110.7z" fill="#ffd17f" />
      <path d="m100 407.8 62.8-80.5c5.9-7.5 16.6-9 24.3-3.3l51.8 38.7c4.1 3.1 9.4 4.2 14.4 3s9.3-4.4 11.6-9l43.2-82.3c3-5.7 8.9-9.3 15.4-9.4 6.5-.1 12.4 3.4 15.5 9.1l74.3 136c3 5.4 2.9 12-.3 17.3-3.2 5.3-8.9 8.6-15.1 8.6h-284c-6.7 0-12.8-3.8-15.7-9.8-3.1-6-2.3-13.2 1.8-18.4zm86.1-131.9c21.9 0 39.7-17.8 39.7-39.7 0-21.9-17.8-39.7-39.7-39.7s-39.7 17.8-39.7 39.7c-.1 22 17.7 39.7 39.7 39.7zm0 0" fill="#fff" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
